export default class BadgeAdder{

    AddTrue(list, searchObject)
    {
        if(searchObject.brand != null || searchObject.brand != undefined)
        {
            const arr = [];
            for(let x = 0; x < list.length; x++)
            {
                if(x == 0)
                {
                    list[x].best = true;
                    arr.push(list[x]);
                }
                else{
                    list[x].best = false;
                    arr.push(list[x]);
                }
            }
            return arr;
        }
        list.forEach(element => {
            element.best != false ? element.best = false : element.best = false;
        });
        return list;
    }
}